import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { getAbsoluteUrl } from "../../utils/domainRouting";
import { V3TertiaryCTAColor } from "../Button/V3TertiaryCTA.types";
import { UnstyledInlineLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3CaptionGrey48 } from "../ReusableStyledComponents/V3CaptionGrey48";
import { V3TertiaryLink } from "../V3TertiaryLink";
import { VerticalSpacing } from "../VerticalSpacing";
import { BuiltFooterBr, V3FooterContainer, V3FooterWrapper, V3LeftS, V3RightS } from "./V3Footer.styles";

const DynamicLogoSection = ({ isPrivateView = false }: { isPrivateView?: boolean }) => (
    <V3LeftS>
        {isPrivateView && (
            <div>
                <img src="/authory_static_files/images/icons/authory_logo_expanded_internal_footer.svg" />
            </div>
        )}
        <div>
            <V3CaptionGrey48>
                {!isPrivateView ? (
                    <>
                        Built with Authory. <BuiltFooterBr />
                        <UnstyledInlineLink
                            target="_blank"
                            href={getAbsoluteUrl(`${APPLICATION_ROUTES.HOMEPAGE}?utm_source=portfolio&utm_medium=footer`)}
                        >
                            Get your own portfolio now!
                        </UnstyledInlineLink>
                    </>
                ) : (
                    "© Authory 2026. All rights reserved."
                )}
            </V3CaptionGrey48>
        </div>
    </V3LeftS>
);

interface V3FooterProps {
    maxWidth?: string;
    isPrivateView?: boolean;
    useExtendedBreakpoint?: boolean;
    showAuthoryBranding?: boolean;
}

export const V3Footer = ({ maxWidth, isPrivateView = false, useExtendedBreakpoint = false, showAuthoryBranding = true }: V3FooterProps) => {
    // On public pages, users who removed Authory branding shouldn't see the Authory footer at all.
    if (!isPrivateView && !showAuthoryBranding) return null;

    return (
        <VerticalSpacing top={isPrivateView ? 20 : 40}>
        <V3FooterContainer>
            <V3FooterWrapper $maxWidth={maxWidth} $useExtendedBreakpoint={useExtendedBreakpoint}>
                <DynamicLogoSection isPrivateView={isPrivateView} />
                <V3RightS>
                    <div>
                        <V3TertiaryLink text="About" ctaColor={V3TertiaryCTAColor.gray} href={getAbsoluteUrl(APPLICATION_ROUTES.ABOUT)} />
                    </div>
                    <div>
                        <V3TertiaryLink text="Imprint" ctaColor={V3TertiaryCTAColor.gray} href={getAbsoluteUrl(APPLICATION_ROUTES.IMPRINT)} />
                    </div>
                    <div>
                        <V3TertiaryLink text="Privacy Policy" ctaColor={V3TertiaryCTAColor.gray} href={getAbsoluteUrl(APPLICATION_ROUTES.PRIVACY)} />
                    </div>
                    <div>
                        <V3TertiaryLink text="Terms" ctaColor={V3TertiaryCTAColor.gray} href={getAbsoluteUrl(APPLICATION_ROUTES.TERMS)} />
                    </div>
                </V3RightS>
            </V3FooterWrapper>
        </V3FooterContainer>
        </VerticalSpacing>
    );
};
